/*
 * (c) Meta Platforms, Inc. and its affiliates.
 */

import React from "react";
import {
	AiFillCheckCircle,
	AiFillMinusCircle,
	AiOutlineClose,
} from "react-icons/ai";
import { useWindowSize } from "react-use";
import { MetadaDataCardData } from "../maps/MapVizClusters";

const EXCLUDED_KEYS = ["url", "image_id"];

declare interface MetaDataCardProps {
	data: MetadaDataCardData;
	setPopupInfo: (data: MetadaDataCardData | null) => void;
}

const MetaDataCard = ({ data, setPopupInfo }: MetaDataCardProps) => {
	const cardRef = React.useRef<HTMLDivElement>(null!);
	const { height } = useWindowSize();

	/**
	 * Format the data from 1's and 0's into icons
	 * for better visualization.
	 * @param entry
	 * @returns
	 */
	const formatBinaryResponse = (entry: string) => {
		switch (entry) {
			case "0":
				return <AiFillMinusCircle color="#F67665" />;
			case "1":
				return <AiFillCheckCircle color="#36D399" />;
			default:
				return entry;
		}
	};

	/**
	 * Returns an array of JSX rows to display metadata
	 * isinde the card.
	 * @returns
	 */
	const dataToDisplay = () => {
		return Object.entries(data).map((i, index) =>
			!EXCLUDED_KEYS.includes(i[0]) ? (
				<div className="px-1 lg:px-2 py-0 grid grid-cols-2 gap-2" key={index}>
					<dt className="text-2xs lg:text-xs font-medium text-gray/70">
						{i[0]}
					</dt>
					<dd className="mt-1 text-2xs lg:text-xs sm:mt-0 text-left">
						{formatBinaryResponse(i[1] as string)}
					</dd>
				</div>
			) : null
		);
	};

	return (
		<div
			ref={cardRef}
			className="absolute top-5 right-5 z-10 w-[340px] bg-black/70 p-4 rounded-lg"
			style={{
				height: "auto",
				maxHeight: `${height * 0.9}px`,
				overflowY: "scroll",
			}}
		>
			<div
				className="absolute top-2 right-2 text-white bg-black p-1 cursor-pointer"
				onClick={() => {
					setPopupInfo(null);
				}}
			>
				<AiOutlineClose />
			</div>
			<img width="100%" src={data.url as string} alt="" />
			<div className="mt-4 text-white" style={{ overflowY: "scroll" }}>
				{dataToDisplay()}
			</div>
		</div>
	);
};

export default MetaDataCard;
